import { render, staticRenderFns } from "./foodlistdetails.vue?vue&type=template&id=2dc43c5f&"
import script from "./foodlistdetails.vue?vue&type=script&lang=js&"
export * from "./foodlistdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports